import { Trans } from 'react-i18next';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { useLanguage } from '../../../hooks';
import { Promo } from '../../../services/content_v1';
import { PromoItem } from '../../Promo/components/PromoList';

interface WelcomePromoProps {
    promo: Promo[],
}

function WelcomePromo({ promo }: WelcomePromoProps) {
    // const { user } = useAuth();
    const lang = useLanguage();

    return (promo.length || 0) > 0 && (
        <section className="welcome-sale">
            <header className="welcome-header">
                <h2 className="welcome-header__heading">
                    <a href={`/${lang}/public-promo`}>
                        <Trans>cms:PROMO</Trans>
                        <LinkTo />
                    </a>
                </h2>
                <div className="welcome-header__link">
                    <a href={`/${lang}/public-promo`}>
                        <Trans>See all</Trans>
                        <LinkTo />
                    </a>
                </div>
            </header>
            <div className="welcome-sale__list">
                {promo.map((item) => (
                    <div key={item.id} className="welcome-sale__list-item">
                        <PromoItem item={item} />
                    </div>
                ))}
            </div>
        </section>
    );
}

export default WelcomePromo;